/** @jsx isolateComponent */

import { MessageBar } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Margin } from '@zapier/design-system';

type CurrencyConversionWarningBarProps = {
  /** The margin to apply to the outside of the component. */
  margin?: string;
};

/**
 * A warning bar that tells the user that they will ultimately be charged in US dollars.
 */
export const CurrencyConversionWarningBar = ({
  margin = '0',
}: CurrencyConversionWarningBarProps) => (
  <Margin margin={margin}>
    <MessageBar
      borderRadius="large"
      hideIcon={true}
      title="Note:"
      type="warning"
    >
      Charges to your account will be made in US Dollars. Converted prices are
      provided as a convenience and are only an estimate based on current
      exchange rates.
    </MessageBar>
  </Margin>
);
